import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  SettlementMethodService,
  SettlementMethodContainerModel,
  Pagination,
  BranchSettlementMethodService,
} from "blg-akaun-ts-lib";
import { of, ReplaySubject } from "rxjs";
import {
  concatMap,
  debounceTime,
  distinctUntilChanged,
  map,
  mergeMap,
  switchMap,
  tap,
} from "rxjs/operators";
import { SubSink } from "subsink2";
import { AppConfig } from "../../visa";

@Component({
  selector: "app-select-settlement-method",
  templateUrl: "./select-settlement-method.component.html",
  styleUrls: ["./select-settlement-method.component.scss"],
})
export class SelectSettlementMethodComponent implements OnInit, OnDestroy {
  @Input() settlement: FormControl;
  @Input() selectedBranchGuid: string;
  @Input() label: string;

  @Output() settlementChange = new EventEmitter<FormControl>();
  @Output() settlementType = new EventEmitter<SettlementMethodContainerModel>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<SettlementMethodContainerModel[]> =
    new ReplaySubject<SettlementMethodContainerModel[]>(1);
  settlementList: SettlementMethodContainerModel[];

  constructor(
    private sms: SettlementMethodService,
    private branchSettlementMethodService: BranchSettlementMethodService
  ) {}

  ngOnInit() {
    let settlementMethodGuidList = [];
    let branchPagination = new Pagination();
    branchPagination.conditionalCriteria.push({
      columnName: "branch_guid",
      operator: "=",
      value: this.selectedBranchGuid,
    });
    this.subs.sink = this.branchSettlementMethodService
      .getByCriteria(branchPagination, this.apiVisa)
      .pipe(
        map((response) => {
          response.data.forEach((link) => {
            settlementMethodGuidList.push(
              link.bl_fi_mst_branch_settlement_method.fi_item_hdr_guid
            );
          });
        }),
        concatMap(() => {
          let settlementMethodPagination = new Pagination();
          settlementMethodPagination.conditionalCriteria.push({
            columnName: "hdr_guids",
            operator: "=",
            value: settlementMethodGuidList.toString(),
          });
          if(settlementMethodGuidList.length>0){
            return this.sms.getByCriteria(settlementMethodPagination, this.apiVisa);
          }else{
            return of(null);
          }
        })
      )
      .subscribe({
        next: (resolve) => {
          if (resolve?.data) {
            const sortedList = resolve?.data.sort((a, b) => 
              a.bl_fi_mst_item_hdr.name.localeCompare(b.bl_fi_mst_item_hdr.name)
            );
            this.settlementList = sortedList;
            this.filteredOptions$.next(this.settlementList);
          }
        },
      });
    this.subs.sink = this.filterControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe({ next: (resolve) => this.filterSettlement(resolve) });
  }

  filterSettlement(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.settlementList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.settlementList?.filter((c) =>
        c.bl_fi_mst_item_hdr.name.toLocaleLowerCase().includes(search)
      );
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const sm = this.settlementList.find((i) =>
      i.bl_fi_mst_item_hdr.guid.includes(e)
    );
    this.settlementType.emit(sm);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
